import FormErrorMessage from '@components/FormErrorMessage';
import PlacingOrderButtons from '@components/PlacingOrderButtons';
import PlacingOrderHeader from '@components/PlacingOrderHeader';
import { ButtonType } from '@components/Button';
import { cancelReturn } from '@api/apiClient';
import { Grid } from '@components/Grid';
import { ICancelModalWindowProps } from '../types';
import { useMutation } from 'react-query';
import { useTranslation } from 'react-i18next';

const CancelModalWindow: React.FC<ICancelModalWindowProps> = (props: ICancelModalWindowProps): React.ReactElement => {
  const { onClose, parcelId, onSuccess } = props;

  const { t } = useTranslation();

  const {
    error: errorCancelReturn,
    isError: isErrorCancelReturn,
    isLoading: isLoadingCancelReturn,
    mutate: mutateCancelReturn
  } = useMutation({
    mutationFn: cancelReturn,
    onSuccess() {
      onClose();
      onSuccess();
    }
  });

  return (
      <Grid>
        <PlacingOrderHeader
            description={t('cancelModalWindow.text')}
            title={t('cancelModalWindow.description')}
        />
        <PlacingOrderButtons
            buttons={[
              {
                action: onClose,
                disabled: isLoadingCancelReturn,
                text: t('disposalModalWindow.no'),
                type: ButtonType.SKELETON
              }, {
                action: () => mutateCancelReturn(parcelId),
                disabled: isLoadingCancelReturn,
                text: t('disposalModalWindow.yes'),
                type: ButtonType.BLOCK
              }
            ]}
        />
        {isErrorCancelReturn && <FormErrorMessage error={errorCancelReturn}/>}
      </Grid>
  );
};

export default CancelModalWindow;